import { useLocation, useParams } from "react-router-dom";
import { TFLocationState } from "types/topicflow";

import { useLink } from "@components/link/link";
import Sidebar from "@components/sidebar/sidebar";

import AssessmentDelivery from "./assessment-delivery";

const AssessmentDeliverySidebarRoute = () => {
  const { deliveryId } = useParams<{ deliveryId: string }>();
  const location = useLocation<TFLocationState>();
  const link = useLink();

  const handleCloseSidebar = () => {
    if (location.state?.background) {
      return link.replace(location.state.background);
    }
    link.redirect("/");
  };

  return (
    <Sidebar onClose={handleCloseSidebar} expandToUrl={location.pathname}>
      <AssessmentDelivery
        assessmentDeliveryId={Number(deliveryId)}
        isInSidebar
      />
    </Sidebar>
  );
};

export default AssessmentDeliverySidebarRoute;
